import { Link, Navigate, Outlet } from "react-router-dom";
import { LogOut, ExternalLink, Loader2 } from "lucide-react";
import { useAuth } from "@/context/AuthContext";

export const AdminGuard = () => {
  const { user } = useAuth();
  if (user === null) return <div className="flex min-h-screen items-center justify-center bg-[#F3F2F8]"><Loader2 className="h-6 w-6 animate-spin text-violet-700" /></div>;
  if (!user) return <Navigate to="/admin/login" replace />;
  return <AdminShell />;
};

const AdminShell = () => {
  const { user, logout } = useAuth();
  return (
    <div className="min-h-screen bg-[#F3F2F8]" data-lenis-prevent>
      <header className="sticky top-0 z-40 border-b border-white/10 bg-[#0B0716]">
        <div className="mx-auto flex h-16 max-w-6xl items-center justify-between px-5">
          <Link to="/admin" data-testid="admin-home-link" className="flex items-center gap-3">
            <img src="/brand/logo-white.png" alt="Perfect Digitals" className="h-9 w-auto" />
            <span className="rounded-full bg-violet-500/20 px-3 py-1 font-mono text-[11px] uppercase tracking-[0.2em] text-violet-200">Blog admin</span>
          </Link>
          <div className="flex items-center gap-2 text-sm">
            <span className="hidden text-slate-300 md:inline">{user.email}</span>
            <Link to="/insights" target="_blank" data-testid="admin-view-site" className="flex items-center gap-1.5 rounded-full px-3 py-2 text-slate-300 hover:bg-white/10 hover:text-white"><ExternalLink className="h-4 w-4" /><span className="hidden sm:inline">View Insights</span></Link>
            <button type="button" onClick={logout} data-testid="admin-logout-button" className="flex items-center gap-1.5 rounded-full px-3 py-2 text-slate-300 hover:bg-white/10 hover:text-white"><LogOut className="h-4 w-4" /><span className="hidden sm:inline">Log out</span></button>
          </div>
        </div>
      </header>
      <main className="mx-auto max-w-6xl px-5 py-10"><Outlet /></main>
    </div>
  );
};
